var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('el-carousel',{attrs:{"indicator-position":"none"}},_vm._l((_vm.list),function(item,i){return _c('el-carousel-item',{key:i},[_c('div',{staticClass:"banner-inner"},[_c('el-image',{attrs:{"src":`${_vm.imageUrl + item.image}`,"fit":"fill"}})],1)])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }